export default __webpack_public_path__ + "static/media/EmptyQuiz.b17cacb7.svg";